export function ensureNonNullable<T>(value: T, label?: string): NonNullable<T> {
	if (value === undefined || value === null) {
		throw new Error(label || 'Expected value to be NonNullable');
	}

	return value;
}

export function assertUnreachable(value: never, label?: string): never {
	throw new Error(
		label || `assertUnreachable should never be called, but it was called with value: ${value}`,
	);
}
